<template>
  <v-container style="position:relative;overflow-y:auto;display:flex;flex-direction:row;height:inherit;">
    <div style="position:absolute;z-index:5;left:26px;top:26px;width:180px!important" class="">
      <v-btn depressed class="custom-header-btn font-italic font-weight-medium" @click="dialogConfirmCancel = true"> <v-icon> mdi-close </v-icon> {{  $t('global.leave')  }}</v-btn>
      <v-img class="mt-10" :style="imageStyle" width="160" height="90" :src="imageFromCanvas" style="border:solid 3px white;border-radius:6px;box-shadow: 0px 7px 9px -4px rgba(0,0,0, 0.1), 0px 14px 21px 2px rgba(0,0,0, 0.07), 0px 5px 26px 4px rgba(0,0,0, 0.06) !important;"></v-img>
    </div>
    <v-dialog v-model="dialogConfirmCancel" persistent overlay-color="dialog" overlay-opacity="0.8" max-width="350px" transition="scale-transition">
      <v-card class="pa-4">
        <v-card-text class="mt-3 title font-italic" style="color:var(--v-primary-base);">
          {{ $t('userMessage.creation-leave-title') }}
        </v-card-text>
        <v-tooltip open-delay="800ms" bottom color="rgba(var(--new-media-rgb),1)">
          <template v-slot:activator="{ on }">
            <img class="mb-2" style="height:274px;width:274px;" src="@/assets/images/illu_delete_newMedia.png"  v-on="on">
          </template>
          <span>Illustration : Ivan Haidutski</span>
        </v-tooltip>
        <v-card-text class="body-2" style="color:var(--v-primary-base);">
          {{ $t('userMessage.creation-leave-message') }}
        </v-card-text>
        <v-card-text class="font-weight-medium" style="color:var(--v-primary-base);"><v-icon class="mr-1">mdi-alert-circle-outline</v-icon>
          {{ $t('userMessage.media-delete-warning') }}
        </v-card-text>
        <v-card-actions>
          <v-btn large rounded depressed text style="width:45%" @click="dialogConfirmCancel = false">{{ $t('global.cancel') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn large outlined rounded style="width:45%" class="custom-valid-btn new-media" @click="closeModal">{{ $t('global.confirm') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-stepper style="margin-left:180px;height:100%!important;width:inherit;overflow-y:auto;" class="d-inline-block" v-model="stepModel" vertical>
      <v-stepper-step @click="goToPreviousStep(1)" step="1" :complete="stepModel > 1">
        <div class="custom-center">
          <v-img id="iconStep" style="position:relative;margin-right:10px;" contain height="48px" width="72px" :src="currentTheme ? iconStep1.darkSrc : iconStep1.lightSrc"></v-img>
          <div class="headline font-weight-light">
            {{  $t('creation.steps.1') }}
            <v-tooltip color="new_media" right>
              <template v-slot:activator="{on}">
                <v-icon id="goBack" class="ml-1" color="primary" style="opacity:0;visibility:hidden" v-on="on">mdi-undo-variant</v-icon>
              </template>
              <span>{{ $t('global.backStep') }}</span>
            </v-tooltip>
          </div>
        </div>
      </v-stepper-step>
      <v-stepper-content step="1" tyle="padding-top:0!important">
        <div class="d-flex flex-wrap">
          <div>
            <v-skeleton-loader :height="canvasHeight" :width="landscapeWidth" v-if="!doneFetchingImage" type="image" class="d-block canvas">
            </v-skeleton-loader>
            <div v-show="doneFetchingImage" style="display:flex;flex-direction:row;">
              <div><!-- Landscape Screen -->
                <v-row no-gutters class="pb-3" style="justify-content:center;">
                  <span style="position:relative;z-index:1;"> {{ $t('global.landscape-screen') }}</span>
                </v-row>
                <v-row no-gutters>
                  <div class="canvas" id="landscapeCanvas"></div>
                </v-row>
              </div>
            </div>
            <div style="margin-left:20px;display:inline-flex!important;flex-direction:row!important;justify-content:start!important;" class="pt-3">
          <!--     <div class="divObject custom-center pl-3" style="height:40px;">
                <v-switch inset hide-details color="new_media" class="form-checkbox" :label="$t('creation.checkboxBanner')" v-model="banner"></v-switch>
              </div> -->
              <v-tooltip open-delay="600" max-width="250" color="new_media" bottom style="border-radius:8em!important;">
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-select
                      :menu-props="{contentClass: 'customSelect'}"
                      color="new_media"
                      item-color="new_media"
                      append-icon="mdi-chevron-down"
                      style="max-width:234px!important;"
                      :items="animations"
                      item-text="name"
                      item-value="id"
                      :return-object="true"
                      v-model="selectedAnimation"
                      width="300"
                      placeholder="Animations"
                      @change="changeBackground"
                      class="custom"
                      :hide-details="true"
                      filled
                      rounded
                      dense
                    ></v-select>
                  </div>
                </template>
                <span>Applique l'animation sélectionnée.</span>
              </v-tooltip>
            </div>
          </div>
          <div class="CreaTextBlock my-6" style="width:480px!important">
            <v-text-field
              color="rgb(var(--new-media-rgb))"
              label="Nom du produit"
              placeholder="Ex: Pavé de saumon"
              v-model="line1"
              @change="addText(1)"
            ></v-text-field>
            <v-text-field
              color="rgb(var(--new-media-rgb))"
              label="Nom du produit (suite)"
              placeholder="Ex: sauvage"
              v-model="line2"
              @change="addText(2)"
            ></v-text-field>
            <v-text-field
              color="rgb(var(--new-media-rgb))"
              label="Promotion"
              placeholder="Ex: 3 achetés"
              v-model="line3"
              @change="addText(3)"
            ></v-text-field>
            <v-text-field
              color="rgb(var(--new-media-rgb))"
              label="Promotion (suite)"
              placeholder="Ex: 1 offert"
              id="promotion-2"
              v-model="line4"
              @change="addText(4)"
            ></v-text-field>
            <v-text-field
              color="rgb(var(--new-media-rgb))"
              label="Origine du produit"
              placeholder="Ex: Origine France"
              v-model="line5"
              @change="addText(5)"
            ></v-text-field>
            <v-text-field
              color="rgb(var(--new-media-rgb))"
              append-icon="mdi-currency-eur"
              label="Prix du produit"
              placeholder="Ex: 5,00"
              v-model="line6"
              type="number"
              @change="addText(6)"
            ></v-text-field>
            <v-text-field
              color="rgb(var(--new-media-rgb))"
              label="Texte libre"
              placeholder="Ex: la pièce"
              v-model="line7"
              @change="addText(7)"
            ></v-text-field>
          </div>
        </div>
        <div style="display:flex;flex-direction:row;justify-content:start;margin-top:20px;">
          <v-btn :disabled="!doneFetchingImage" rounded large depressed color="new_media" style="padding:0px 4px 0px 14px!important;color:white!important;" @click="toStepTwo"> {{  $t('creation.steps.2') }} <v-icon large class="ml-2">mdi-arrow-down-circle</v-icon> </v-btn>
        </div>
      </v-stepper-content>
      <v-stepper-step @click="goToPreviousStep(2)" :complete="stepModel > 2" step="2">
        <div class="custom-center">
          <v-img id="iconStep" style="position:relative;margin-right:10px;" contain height="48px" width="72px" :src="currentTheme ? iconStep2.darkSrc : iconStep2.lightSrc"></v-img>
          <div class="headline font-weight-light"> {{  $t('creation.steps.2') }}
            <v-tooltip color="new_media" right>
              <template v-slot:activator="{on}">
                <v-icon id="goBack" class="ml-1" color="primary" style="opacity:0;visibility:hidden" v-on="on">mdi-undo-variant</v-icon>
              </template>
              <span>{{ $t('global.backStep') }}</span>
            </v-tooltip>
          </div>
        </div>
      </v-stepper-step>
      <v-stepper-content step="2">
        <div>
            <div class="d-inline-block vert-align-top mr-10">
              <h3 class="mb-2">
                Programmation
              </h3>
              <div class="mb-4 d-flex flex-column">
                <span class="caption text-center">Début de diffusion</span>
                <v-menu
                  ref="startingDate"
                  v-model="menuStartingDate"
                  :close-on-content-click="false"
                  :return-value.sync="startingDate"
                  transition="scale-transition"
                  min-width="290px"
                  >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="startingDate"
                      :readonly="true"
                      :hide-details="true"
                      :single-line="true"
                      v-on="on"
                      class="custom-text-field"
                      color="new_media"
                      style="width:180px!important;"
                      prepend-inner-icon="mdi-calendar-check"
                      outlined
                      rounded
                      dense
                    ></v-text-field>
                  </template>
                  <v-date-picker light color="new_media" style="background-color:white;" first-day-of-week="1" reactive v-model="startingDate" scrollable :locale="$store.state.user.language">
                    <v-btn rounded text style="width:45%;" class="mb-2 ml-2" @click="menuStartingDate = false">Annuler</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn rounded outlined style="width:45%;" class="custom-valid-btn new-media mb-2 mr-2" @click="$refs.startingDate.save(startingDate)">Valider</v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
              <div class="d-flex flex-column">
                <span class="caption text-center">Fin de diffusion</span>
                <v-menu
                  ref="endingDate"
                  v-model="menuEndingDate"
                  :close-on-content-click="false"
                  :return-value.sync="endingDate"
                  transition="scale-transition"
                  min-width="290px"
                  >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="endingDate" 
                      placeholder="_ _ _ _-_ _-_ _"
                      :readonly="true"
                      :hide-details="true"
                      :single-line="true"
                      v-on="on"
                      class="custom-text-field"
                      color="new_media"
                      style="width:180px!important;"
                      prepend-inner-icon="mdi-calendar-remove"
                      outlined
                      rounded
                      dense
                      clearable
                      clear-icon="mdi-close-circle"
                    ></v-text-field>
                  </template>
                  <v-date-picker light color="new_media" style="background-color:white;" first-day-of-week="1" reactive v-model="endingDate" scrollable :locale="$store.state.user.language">
                    <v-spacer></v-spacer>
                    <v-btn rounded text style="width:45%;" class="mb-2 ml-2" @click="menuEndingDate = false">Annuler</v-btn>
                    <v-btn rounded outlined style="width:45%;" class="custom-valid-btn new-media mb-2 mr-2" @click="$refs.endingDate.save(endingDate)">Valider</v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
            </div>
            <div class="d-inline-block broadcast-days-div mr-10">
              <h3 class="mb-2">
                {{ $t('newMedia.broadcastDays') }}
              </h3>
              <div id="broadcastDays_container" style="display:flex; flex-direction:column; height:100%; max-width:380px;">
                  <v-row no-gutters>
                    <template v-for="day in broadcastDays">
                      <v-col :key="day.id" >
                        <div class="divObject custom-center pl-3" style="background-color:transparent;width:180px!important;margin-right:0!important;">
                          <v-switch inset dense hide-details class="form-checkbox" color="new_media" :label="day.name" v-model="chosenDays" :value="day">
                          </v-switch>
                        </div>
                      </v-col>
                    </template>
                  </v-row>
              </div>
            </div>
            <div class="d-inline-block vert-align-top" style="width:280px!important;overflow:visible;">
              <h3 class="mb-2">
                Horaires de diffusion
              </h3>
              <div v-if="setBroadCastHours" class="pt-4 elevation-24-05" style="border-radius:18px;background-color:var(--v-contrast-base)!important;">
                <p class="px-4 text-center">Plage horaire activée<v-icon class="ml-2" color="new_media">mdi-check-circle</v-icon></p>
                <div class="d-flex flex-row justify-space-between px-4 mb-4">
                  <div class="d-flex flex-column">
                    <span class="caption mb-1">Commence à </span>
                    <vue-time-picker :minute-interval="10" class="custom-time-picker" color="new_media" v-model="startingHour">
                    </vue-time-picker>
                  </div>
                  <div class="d-flex flex-column">
                    <span class="caption mb-1">Se termine à </span>
                    <vue-time-picker :minute-interval="10" class="custom-time-picker" color="new_media" v-model="endingHour">
                    </vue-time-picker>
                  </div>
                </div>
                <v-btn
                  depressed
                  block
                  dark
                  color="var(--v-error-darken1)"
                  style="border-radius:0 0 18px 18px;text-transform:none;"
                  @click="removeHours">
                  <v-icon class="mr-2">
                    mdi-chevron-right
                  </v-icon>
                  Diffuser toute la journée
                  <v-icon class="ml-2">
                    mdi-chevron-left
                  </v-icon>
                </v-btn>
              </div>
              <div v-if="!setBroadCastHours" class="pt-4 elevation-24-05" style="border-radius:18px;background-color:var(--v-contrast-base)!important;">
                <p class="px-4 text-center">
                  Diffusion toute la journée
                  <v-icon class="ml-2" color="new_media">
                    mdi-check-circle
                  </v-icon>
                </p>
                <v-btn
                  depressed
                  block
                  dark
                  color="new_media"
                  class="font-weight-medium"
                  style="border-radius:0 0 18px 18px;text-transform:none;"
                  @click="setBroadCastHours = true">
                <v-icon class="mr-2">
                  mdi-chevron-right
                </v-icon>
                  Activer une plage horaire
                <v-icon class="ml-2">
                  mdi-chevron-left
                </v-icon>
                </v-btn>
              </div>
            </div>
          </div>
          <div style="height:auto;max-height:500px;;overflow-x:hidden;overflow-y:auto;">
            <h3>
              Selection des écrans de diffusion ({{ chosenScreens.length }})
            </h3>
            <v-row no-gutters>
              <template v-for="screen in availableScreens">
                <v-col :key="screen.id" class="align-start col-lg-2 col-md-3 col-sm-6" v-if="screen.fk_screen_type === 1">
                  <div v-if="!chosenScreens.includes(screen)" class="d-flex flex-column justify-center align-center select-screen-container">
                    <div class="elevation-0 select-screen-image-bloc" @click="addScreen(screen)">
                      <v-img class="select-screen-image" contain :src="screenIcon(screen.fk_screen_type)" >
                        <v-btn small fab dark color="var(--v-new_media-base)!important" class="select-screen-button">
                          <v-icon color="white">mdi-plus</v-icon>
                        </v-btn>
                      </v-img>
                    </div>
                    <div >
                      <span> {{ screen.server_name.replace(/_/g,' ') }} </span>
                    </div>
                  </div>
                  <div v-if="chosenScreens.includes(screen)" class="d-flex flex-column justify-center align-center select-screen-container">
                    <div class="elevation-12 new_media select-screen-image-bloc" style="background-color:var(--v-new_media-base);" @click="removeScreen(screen)">
                      <v-img class="select-screen-image" contain :src="screenIcon(screen.fk_screen_type)" >
                        <v-btn small fab dark color="var(--v-primary-base)!important" class="select-screen-button">
                          <v-icon color="var(--v-contrast-base)!important">mdi-minus</v-icon>
                        </v-btn>
                      </v-img>
                    </div>
                    <div >
                      <span> {{ screen.server_name.replace(/_/g,' ') }} </span>
                    </div>
                  </div>
                </v-col>
              </template>
            </v-row>
            <!-- <div>
              <v-checkbox color="new_media" class="d-inline-block" v-for="screen in availableScreens" :key="screen.id" :label="screen.server_name" v-model="chosenScreens" :value="screen"></v-checkbox>
            </div> -->
          </div>
          <div>
            <v-btn rounded large depressed color="new_media" style="padding:0px 4px 0px 14px!important;color:white!important;" :disabled="chosenScreens.length<1 || chosenDays.length<1 || ((!isStartingHourValid || !isEndingHourValid) && setBroadCastHours)" @click="toStepThree">{{  $t('creation.steps.3') }} <v-icon large class="ml-2">mdi-arrow-down-circle</v-icon> </v-btn>
          </div>
      </v-stepper-content>
      <v-stepper-step step="3">
        <div class="custom-center">
          <v-img id="iconStep" style="position:relative;margin-right:10px;" contain height="48px" width="72px" :src="currentTheme ? iconStep3.darkSrc : iconStep3.lightSrc"></v-img>
          <div class="headline font-weight-light"> {{  $t('creation.steps.3') }} </div>
        </div>
      </v-stepper-step>
      <v-stepper-content step="3">
        <div class="d-inline-flex flex-column">
          <div class="d-inline-flex flex-row elevation-8-05" style="border-radius:10px!important;overflow:hidden;">
            <div class="pa-3 d-inline-flex flex-column justify-center align-end" style="color:white;background-color:var(--v-new_media-base);width:230px;">
              <span>
                <v-icon dark>mdi-calendar-month</v-icon>
                Programmation
              </span>
              <span v-html="schedule" class="font-italic font-weight-regular" style="text-align:right;margin-bottom:10px;"> 
              </span>
              <span>
                <v-icon dark>mdi-calendar-check</v-icon>
                Jours de diffusion
              </span>
              <div class="d-flex flex-row flex-wrap justify-end" style="margin-bottom:10px;">
                <span class="font-italic font-weight-regular text-right" v-html="orderedDays">
                </span>
              </div>

              <div v-if="setBroadCastHours">
                <span >
                  <v-icon dark>mdi-clock-outline</v-icon>
                  Horaires de diffusion
                </span>
                <div class="d-flex flex-row flex-wrap justify-end">
                  <span class="font-italic font-weight-regular">
                    {{ hours }}
                  </span>
                </div>
              </div>
            </div>
            <div v-if="selectedLandscapeScreens.length > 0"> 
              <v-img v-if="imageFromCanvas" :src="imageFromCanvas" width="480" height="270">
              </v-img>
            </div>
          </div>
        </div>
          <div class="d-flex" style="width:450px">
            <v-icon x-large color="new_media">mdi-subdirectory-arrow-right</v-icon>
            <v-text-field
                label="Nommez votre média pour mieux le retrouver !"
                v-model="animationName"
                color="new_media"
                class="mt-4 pt-3 ml-1"
                outlined
                rounded
                dense
              ></v-text-field>
          </div>
          <div class="d-flex custom-center">
            <v-icon color="new_media" large>mdi-television-play</v-icon>
            <h4 class="ml-3 font-weight-medium">Votre média sera diffusé sur le ou les écrans suivants :</h4>
          </div>
          <div class="d-flex custom-center">
            <span class="font-weight-regular"> {{ screenList }} </span>
          </div>
        <div style="margin-top:20px;">
          <v-btn rounded :loading="loading" large depressed color="new_media" style="padding:0px 4px 0px 14px!important;color:white!important;" @click="uploadAnimation" :disabled="animationName === null || animationName === ''">
            Envoyer en diffusion
            <v-icon large class="mx-2">
              mdi-television-play
            </v-icon>
          </v-btn>
          <span class="ml-2">
            {{ uploadMessage }}
          </span>
        </div>
      </v-stepper-content>
    </v-stepper>
  </v-container>
</template>

<script>
import Konva from 'konva'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import FtpService from '@/services/FTPService'
import DBService from '@/services/DBService'
/* const fs = require('fs') */
const landscapeScale = 480 / 1366
var landscapeStage
var landscapeLayer
/* eslint-disable no-new, new-cap */
export default {
  data () {
    return {
      stepModel: 1,
      file: null,
      imageURL: null,
      image: null,
      animations: [],
      selectedAnimation: null,
      startingDate: new Date().toISOString().substr(0, 10),
      endingDate: null,
      menuStartingDate: false,
      menuEndingDate: false,
      modal: false,
      menu2: false,
      imageFromCanvas: '',
      broadcastDays: [
        { id: 0, code: '', name: this.$i18n.t('global.days.0') },
        { id: 4, code: 'J', name: this.$i18n.t('global.days.4') },
        { id: 1, code: 'L', name: this.$i18n.t('global.days.1') },
        { id: 5, code: 'V', name: this.$i18n.t('global.days.5') },
        { id: 2, code: 'A', name: this.$i18n.t('global.days.2') },
        { id: 6, code: 'S', name: this.$i18n.t('global.days.6') },
        { id: 3, code: 'R', name: this.$i18n.t('global.days.3') },
        { id: 7, code: 'D', name: this.$i18n.t('global.days.7') }
      ],
      months: [
        { id: 1, name: 'janvier' },
        { id: 2, name: 'février' },
        { id: 3, name: 'mars' },
        { id: 4, name: 'avril' },
        { id: 5, name: 'mai' },
        { id: 6, name: 'juin' },
        { id: 7, name: 'juillet' },
        { id: 8, name: 'août' },
        { id: 9, name: 'septembre' },
        { id: 10, name: 'octobre' },
        { id: 11, name: 'novembre' },
        { id: 12, name: 'décembre' },
      ],
      chosenDays: [{ id: 0, code: '', name: this.$i18n.t('global.days.0') }],
      nameExtension: '',
      availableScreens: null,
      chosenScreens: [],
      startingHour: {
        HH: '',
        mm: '00'
      },
      endingHour: {
        HH: '',
        mm: '00'
      },
      displayTime: '10',
      isStartingHourValid: true,
      isEndingHourValid: true,
      snackbarUploadSuccessful: false,
      snackbarUploadFailed: false,
      resizedImage: null,
      timeoutDuration: 4000,
      doneFetchingImage: false,
      canvasHeight: 270,
      landscapeWidth: 480,
      portraitWidth: 152,
      ledWidth: 360,
      line1: '',
      line2: '',
      line3: '',
      line4: '',
      line5: '',
      line6: '',
      line7: '',
      imgSrcLandscape: require('@/assets/images/light_ic_screen_landscape.png'),
      imgSrcPortrait: require('@/assets/images/light_ic_screen_portrait.png'),
      imgSrcLED: require('@/assets/images/light_ic_screen_led.png'),
      iconStep1: {lightSrc: require('../../assets/images/light_ic_creation_step1.png'), darkSrc: require('../../assets/images/dark_ic_creation_step1.png')},
      iconStep2: {lightSrc: require('../../assets/images/light_ic_creation_step2.png'), darkSrc: require('../../assets/images/dark_ic_creation_step2.png')},
      iconStep3: {lightSrc: require('../../assets/images/light_ic_creation_step3.png'), darkSrc: require('../../assets/images/dark_ic_creation_step3.png')},
      imageStyle: 'transform:scale(0);-ms-transform:scale(0); transition: transform 300ms;',
      currentTheme: null,
      dialogConfirmCancel: false,
      banner: true,
      bannerPath: '',
      dateText: '',
      loading: false,
      landscapeBanner: '',
      roundedImage: '',
      hasLandscapeScreens: false,
      setBroadCastHours: false,
      uploadMessage: '',
      selectedLandscapeScreens: [],
      animationName: ''
    }
  },
  components: {
    'vueTimePicker': VueTimepicker
  },
  created () {
    this.currentTheme = this.$store.state.theme
  },
  async mounted () {
    this.availableScreens = this.$store.state.selectedSite.screens.filter(screen => screen.fk_screen_type === 1)
     this.availableScreens.forEach(screen => {
      if (screen.fk_screen_type === 1) {
        this.hasLandscapeScreens = true
      } /* else if (screen.fk_screen_type === 2) {
        this.hasPortraitScreens = true
      } else if (screen.fk_screen_type === 3) {
        this.hasLedScreens = true
      } */
    })
    this.file = this.$store.state.file
    /* const bannerResponse = await FtpService.fetchBanner({
      site: this.$store.state.selectedSite
    })
    if (this.hasLandscapeScreens) {
      this.landscapeBanner = 'https://sandisplay.allsan.fr/players/rayontrad/' + this.$store.state.selectedSite.SitNom + '/bandeau/' + bannerResponse.data.landscapebanner 
    } */
    if (!this.file) {
      this.imageURL = this.$store.state.pixabayImageURL
      this.setSources()
    } else {
      var reader = new FileReader()
      reader.onload = (e) => {
        this.imageURL = e.target.result
        this.setSources()
      }
      reader.readAsDataURL(this.file)
    }
    this.importAnimations(require.context('../../assets/images/animations/', true, /\.jpg$/))
    if (this.$store.state.selectedSite.SitNom !== 'TESTS') {
      this.landscapeBanner = 'https://sandisplay.allsan.fr/players/rayontrad/Animations/Bandeaux/' + this.$store.state.selectedSite.split('_')[0] + '_Bando.png'
      this.bannerPath = this.$store.state.selectedSite.split('_')[0]
    } else {
      this.landscapeBanner = 'https://sandisplay.allsan.fr/players/rayontrad/Animations/Bandeaux/ALLSAN_Bando.png' 
      this.bannerPath = 'ALLSAN'
    }
 },
  methods: {
    goToPreviousStep (clickedStep) {
      if (this.stepModel > clickedStep) {
        this.stepModel = clickedStep
      }
      if (this.stepModel === 1) {
        this.imageFromCanvas = ''
      }
    },
    closeModal () {
      this.$store.dispatch('setMediaToEdit', null)
      this.$store.dispatch('setFile', null)
      this.$store.dispatch('setPixabayImageID', 0)
      this.$store.dispatch('setPixabayImageURL', null)
      this.$store.dispatch('setUploadSuccessful', false)
      this.$emit('close')
    },
    removeHours () {
      this.setBroadCastHours = false
      this.endingHour.HH = ''
      this.endingHour.mm = '00'
      this.startingHour.HH = ''
      this.startingHour.mm = '00'
      this.isEndingHourValid = false
      this.isStartingHourValid = false
    },
    addScreen (screen) {
      this.chosenScreens.push(screen)
    },
    removeScreen (screen) {
      this.chosenScreens = this.chosenScreens.filter(function (element) {
        if (element.id !== screen.id) {
          return element
        }
      })
    },
    importAnimations (r) {
      var i = 0
      r.keys().forEach(key => (
        this.animations.push({ id: i++, path: key, longPath: r(key), name: key.substring(2).split('.')[0].replace(/_/g, ' ') })
      ))
      if (!this.selectedAnimation) {
        this.selectedAnimation = this.animations[this.animations.length - 1]
        this.changeBackground()
      }
    },
    toStepTwo () {
      this.stepModel = 2
      this.getHDCanvas(() => {
        this.imageFromCanvas = landscapeStage.toDataURL()
      })
      landscapeLayer.find('Transformer').destroy()
      drawLayer()
    },
    toStepThree () {
      this.addDate()
      this.imageFromCanvas = landscapeStage.toDataURL()
      landscapeStage.width(1366)
      landscapeStage.height(768)
      landscapeStage.scaleX(1 / landscapeScale)
      landscapeStage.scaleY(1 / landscapeScale)
      this.resizedImage = landscapeStage.toDataURL()
      landscapeStage.scaleX(1)
      landscapeStage.scaleY(1)
      landscapeStage.width(480)
      landscapeStage.height(270)
      drawLayer()
      this.stepModel = 3
      this.nameExtension = '__jd'

      this.selectedLandscapeScreens = this.chosenScreens.filter(function (element) {
        return element.fk_screen_type === 1
      })
      this.selectedPortraitScreens = this.chosenScreens.filter(function (element) {
        return element.fk_screen_type === 2
      })
      this.selectedLedScreens = this.chosenScreens.filter(function (element) {
        return element.fk_screen_type === 3
      })
      this.stepModel = 3
      this.nameExtension = '__jd'
      this.selectedDaysIDCSV = ''
      for (let i = 0; i < this.chosenDays.length; i++) {
        if (this.chosenDays[i].id === 0) {
          this.selectedDaysIDCSV = '0,'
          this.nameExtension = ''
          break
        } else {
          this.nameExtension += this.chosenDays[i].code
          this.selectedDaysIDCSV += this.chosenDays[i].id + ','
        }
      }
      this.selectedDaysIDCSV = this.selectedDaysIDCSV.substring(0, this.selectedDaysIDCSV.length - 1)
       if (this.setBroadCastHours) {
        if (this.startingHour) {
          let minutes = this.startingHour.mm === '' ? '00' : this.startingHour.mm
          let hours = this.startingHour.HH
          this.nameExtension += '__hd' + hours + minutes
          this.startingHourFormat = hours + minutes
        }
        if (this.endingHour) {
          let minutes = this.endingHour.mm === '' ? '00' : this.endingHour.mm
          let hours = this.endingHour.HH
          this.nameExtension += '__hf' + hours + minutes
          this.endingHourFormat = hours + minutes
        }
      }
      if (this.startingDate) {
        let dateElements = this.startingDate.split('-')
        this.nameExtension += '__d' + dateElements[0] + dateElements[1] + dateElements[2]
      }
      if (this.endingDate) {
        let dateElements = this.endingDate.split('-')
        this.nameExtension += '__f' + dateElements[0] + dateElements[1] + dateElements[2]
      }
    },
    getHDCanvas (callback) {
      this.landscapeStage = {
        width: 1366,
        height: 768,
        scaleX: 1 / landscapeScale,
        scaleY: 1 / landscapeScale
      }
      setTimeout(() => {
        callback()
        this.landscapeStage = {
          width: 480,
          height: 270,
          scaleX: 1,
          scaleY: 1
        }
      }, 0)
    },
    screenIcon (screenType) {
      if (screenType === 1) {
        return this.imgSrcLandscape
      } else if (screenType === 2) {
        return this.imgSrcPortrait
      } else if (screenType === 3) {
        return this.imgSrcLED
      }
    },
    addText (element) {
      var fontSize
      var fontFamily = 'arial'
      var fill = 'white'
      var fontStyle
      if (element === 1 || element === 2) {
        fontSize = 19
        fontStyle = 'bold'
        let text = new Konva.Text({
          fontSize: fontSize,
          fill: fill,
          fontFamily: fontFamily,
          fontStyle: fontStyle
        })
        if (element === 1) {
          if (landscapeLayer.find('#animation-line-1').length > 0) {
            landscapeLayer.find('#animation-line-1').destroy()
          }
          text.text(this.line1)
          text.id('animation-line-1')
          text.y(63)
        } else {
          if (landscapeLayer.find('#animation-line-2').length > 0) {
            landscapeLayer.find('#animation-line-2').destroy()
          }
          text.text(this.line2)
          text.id('animation-line-2')
          text.y(86)
        }
        text.x(480 - 16 - text.width())
        landscapeLayer.add(text)
      } else if (element === 3 || element === 4) {
        fontSize = 17
        fontStyle = 'italic'
        let text = new Konva.Text({
          fontSize: fontSize,
          fill: fill,
          fontFamily: fontFamily,
          fontStyle: fontStyle
        })
        if (element === 3) {
          if (landscapeLayer.find('#animation-line-3').length > 0) {
            landscapeLayer.find('#animation-line-3').destroy()
          }
          text.text(this.line3)
          text.id('animation-line-3')
          text.y(115)
        } else {
          if (landscapeLayer.find('#animation-line-4').length > 0) {
            landscapeLayer.find('#animation-line-4').destroy()
          }
          text.text(this.line4)
          text.id('animation-line-4')
          text.y(136)
        }
        text.x(480 - 16 - text.width())
        landscapeLayer.add(text)
      } else if (element === 5 || element === 7) {
        fontSize = 17
        let text = new Konva.Text({
          fontSize: fontSize,
          fill: fill,
          fontFamily: fontFamily
        })
        if (element === 5) {
          if (landscapeLayer.find('#animation-line-5').length > 0) {
            landscapeLayer.find('#animation-line-5').destroy()
          }
          text.text(this.line5)
          text.id('animation-line-5')
          text.y(165)
        } else {
          if (landscapeLayer.find('#animation-line-7').length > 0) {
            landscapeLayer.find('#animation-line-7').destroy()
          }
          text.text(this.line7)
          text.id('animation-line-7')
          text.y(224)
        }
        text.x(480 - 16 - text.width())
        landscapeLayer.add(text)
      } else if (element === 6) {
        if (landscapeLayer.find('#animation-line-6').length > 0) {
          landscapeLayer.find('#animation-line-6').destroy()
        }
        fontSize = 36
        var validPrice = this.line6
        if (this.line6) {
          validPrice = validPrice * 1.0
          validPrice = validPrice.toFixed(2)
          this.line6 = validPrice
          validPrice = validPrice.toString().replace(/\./g, ',') + ' €'
        }
        let text = new Konva.Text({
          fontSize: fontSize,
          fill: fill,
          fontFamily: fontFamily,
          y: 193,
          text: validPrice,
          id: 'animation-line-6'
        })
        text.x(480 - 16 - text.width())
        landscapeLayer.add(text)
      }
      drawLayer()
    },
    addDate () {
      var fontSize = 19
      var fontFamily = 'arial'
      var fill = 'white'
      if (landscapeLayer.find('#dateText').length > 0) {
        landscapeLayer.find('#dateText')[0].destroy()
      }
      let text = new Konva.Text({
        fontSize: fontSize,
        fill: fill,
        fontFamily: fontFamily,
        text: this.dateText,
        id: 'dateText',
        y: 14
      })
      text.x(480 - 16 - text.width())
      landscapeLayer.add(text)
      drawLayer()
      this.imageFromCanvas = landscapeStage.toDataURL()
    },
    async uploadAnimation () {
      var random = Math.floor(Math.random() * Math.floor(4)) + 1
      var animation = this.selectedAnimation.name.replace(' ', '_')
      setTimeout( () => {
        this.uploadMessage = 'La durée de cette opération dépend de votre connexion Internet.'
      }, 1000)
      this.loading = true
      var uniqueID = Date.now()
      var propertiesDataObject = {
        titre: this.animationName,
        bandeauEnseigne: true,
        etat: 1,
        selectedDays: this.selectedDaysIDCSV,
        dateDebut: this.startingDate,
        dateFin: this.endingDate,
        heureDebut: this.startingHourFormat,
        heureFin: this.endingHourFormat,
        pixabayID: this.$store.state.pixabayImageID,
        tpf: 10,
        cadrage_paysage: null,
        cadrage_portrait: null
      }
      var byteCharacters = this.resizedImage.split(',')[1]     
      var roundedImage = this.roundedImage.split(',')[1]
      const response = await FtpService.uploadAnimation({ b64: byteCharacters,
        animation: animation,
        image: roundedImage,
        videoSettings: this.nameExtension,
        site: this.$store.state.selectedSite,
        screens: this.chosenScreens,
        uniqueID: uniqueID,
        bannerPath: this.bannerPath,
        l1product: this.line1,
        l2product: this.line2,
        l1desc: this.line3,
        l2desc: this.line4,
        l1info: this.line5,
        price: this.line6,
        priceInfo: this.line7,
        date: this.dateText
      })
      if (response) {
        if (response.status === 200) {
           const dbResponse = await DBService.registerMediaProperties({
              imageSettings: this.nameExtension,
              site: this.$store.state.selectedSite,
              screens: this.chosenScreens,
              propertiesData: propertiesDataObject,
              uniqueID: uniqueID,
              user: this.$store.state.user.id,
              isVideo: true,
              random: random
            })
            if (dbResponse) {
              if (dbResponse.status === 200) {
                this.$emit('close')
                this.$router.replace({
                  name: 'MyContent'
                })
              }
            }
          this.snackbarUploadSuccessful = true
        } else {
          this.snackbarUploadFailed = true
        }
      }
    },
    setSources () {
      landscapeStage = new Konva.Stage({
        container: 'landscapeCanvas',
        width: 480,
        height: 270
      })
      landscapeLayer = new Konva.Layer()

      let imageBorder = new Konva.Rect({
        id: 'imageAnimation',
        x: 24,
        y: 63,
        width: 220,
        height: 144,
        cornerRadius: 71,
        stroke: 'white',
        strokeWidth: 3
      })

      let imageBorderResized = new Konva.Rect({
        width: 871,
        height: 567,
        cornerRadius: 282,
      })
      
      new Konva.Image.fromURL(this.imageURL, (image) => {
        image.size({
          width: 871,
          height: 567
        })
        image.toImage({
          callback: (img) => {
            imageBorderResized.fillPatternImage(img)
            this.roundedImage = imageBorderResized.toDataURL()
          }
        })
      })

      new Konva.Image.fromURL(this.imageURL, (image) => {
        image.size({
          width: 1366,
          height: 768
        })
        image.scaleX(220 / 1366)
        image.scaleY(144 / 768)
        image.id('landscapeBackground')
        image.toImage({
          callback (img) {
            imageBorder.fillPatternImage(img)
            landscapeLayer.add(imageBorder)
            drawLayer()
          }
        })
        var landscapeBanner = this.landscapeBanner
        new Konva.Image.fromURL(landscapeBanner, (image) => {
            image.size({
              width: 480,
              height: 270
            })
            image.id('banner')
            landscapeLayer.add(image)
            landscapeLayer.draw()
        })
        this.doneFetchingImage = true
      })
      landscapeStage.add(landscapeLayer)
    },
    changeBackground: function () {
      if (landscapeLayer.find('#animation-background').length > 0) {
        landscapeLayer.find('#animation-background').destroy()
      }
      var animationBackground = new Image()
      animationBackground.onload = function () {
        var img = new Konva.Image({
          id: 'animation-background',
          x: 0,
          y: 0,
          image: animationBackground,
          width: 1366,
          height: 768,
          scaleX: landscapeScale,
          scaleY: landscapeScale
        })
        // add the shape to the layer
        landscapeLayer.add(img)
        img.moveToBottom()
        drawLayer()
      }
      animationBackground.src = this.selectedAnimation.longPath
    }
  },
  computed: {
    schedule: function () {
      if (this.endingDate) {
        let dateElements = this.startingDate.split('-')
        let dateElements2 = this.endingDate.split('-')
        if (parseInt(dateElements[1], 10) === parseInt(dateElements2[1], 10)) {
          this.dateText = 'Du ' + parseInt(dateElements[2], 10) + ' au ' + parseInt(dateElements2[2], 10) + ' ' + this.months[parseInt(dateElements2[1], 10) - 1].name
        } else {
          this.dateText = 'Du ' + parseInt(dateElements[2], 10) + ' ' + this.months[parseInt(dateElements[1], 10) - 1].name + ' au ' + parseInt(dateElements2[2], 10) + ' ' + this.months[parseInt(dateElements2[1], 10) - 1].name
        }
        return 'Du ' + this.startingDate + ' au ' + this.endingDate + '.'
      } else {
        let dateElements = this.startingDate.split('-')
        this.dateText = 'A partir du ' + parseInt(dateElements[2], 10) + ' ' + this.months[parseInt(dateElements[1], 10) - 1].name
        return 'À partir du ' + this.startingDate + '.'
      }
    },
    hours: function () {
      if (this.startingHour.HH && this.startingHour.mm && this.endingHour.HH && this.endingHour.mm) {
        return 'entre ' + this.startingHour.HH + ':' + this.startingHour.mm + ' et ' + this.endingHour.HH + ':' + this.endingHour.mm
      } else {
        return ''
      }
    },
    orderedDays: function () {
      var days = []
      var returnValue = ''
      for (let i = 0; i < this.chosenDays.length; i++) {
        if (this.chosenDays[i].id === 0) {
          return this.chosenDays[i].name
        } else {
          days = this.chosenDays.slice().sort(compareById)
          days.forEach(function(element) {
            returnValue += element.name + ', '
          })
          return returnValue.substring(0, returnValue.length-2)
        }
      }
    },
    screenList: function () {
      var screenList = ''
      for (let i = 0; i < this.chosenScreens.length; i++) {
       screenList += this.chosenScreens[i].server_name + ', '
      }
      return screenList.substring(0, screenList.length-2)
    },
  },
  watch: {
    startingHour: function () {
      if (!this.setBroadCastHours) {
        this.isStartingHourValid = true
      } else if (!(this.startingHour.HH !== '' && this.startingHour.mm !== '')) {
        this.isStartingHourValid = false
      } else {
        this.isStartingHourValid = true
      }
    },
    endingHour: function () {
      if (!this.setBroadCastHours) {
        this.isEndingHourValid = true
      } else if (!(this.endingHour.HH !== '' && this.endingHour.mm !== '')) {
        this.isEndingHourValid = false
      } else {
        this.isEndingHourValid = true
      }
    },
    chosenDays: function () {
      for (let i = 0; i < this.chosenDays.length; i++) {
        if (this.chosenDays[i].id === 0 && this.chosenDays.length > 1) {
          this.chosenDays.splice(i, 1)
          break
        }
      }
    },
    banner: function () {
      if (this.banner) {
        var landscapeBanner = this.landscapeBanner
        new Konva.Image.fromURL(landscapeBanner, (image) => {
            image.size({
              width: 480,
              height: 270
            })
            image.id('banner')
            landscapeLayer.add(image)
            landscapeLayer.draw()
        })
        this.bannerPath = this.landscapeBanner
      } else {
         if (this.hasLandscapeScreens) {
          landscapeLayer.find('#banner').destroy()
        }
        this.bannerPath = ''
      }
    },
  }
}

function drawLayer () {
  if (landscapeLayer) {
    landscapeLayer.draw()
  }
}

function compareById (a, b) {
  if (a.id < b.id) {
    return -1
  }
  if (a.id > b.id) {
    return 1
  }
  return 0
}
</script>

<style scoped>
.vert-align-top{
  vertical-align: top;
}

.divAddBlock{
  display: block;
  overflow-y: visible;
}

.divObject{
  vertical-align: top;
  /* display: inline-block; */
  display: flex;
  margin-right: 14px;
/*   background-color:rgba(85, 86, 94, 0.10);
 */  background-color: rgba(9, 5, 33,0.1);
  height:36px;
  width:auto;
  border-radius:50em;
}

.divObjectStickers{
  vertical-align: top;
  /* display: inline-block; */
  display: flex;
  margin-right: 14px;
/*   background-color:rgba(85, 86, 94, 0.10);*/
  height:36px;
  width:auto;
  border-radius:50em;
}

.icon-list-container{
  border-radius: 0px 16px 16px 16px;
  overflow: hidden;
}

.icon-list {
  background-color: var(--v-contrast-base)!important;
  max-width: 600px;
  height: 270px;
  overflow:auto;
  padding: 4px;
}

.icon-list-item{
  position:relative;
  height: 100px!important;
  width: 100px!important;
  margin:4px;
}

.form-checkbox {
  margin: auto;
  display: flex;
/*   display: block;
 */  margin-right: 10px;
  padding-top:0px!important;
  margin-left:-2px!important;
}

.divBlock{
  overflow: visible;
  width: 100%;
  display:flex;
  flex-direction:column;
}

.div-align-top{
  vertical-align: top;
}

.broadcast-days-div{
  max-width: 500px;
}

.btnAddContent{
  height: 25px;
  width: 25px;
}

.select-screen-container{
  position:relative;
  width:180px!important;
  height:180px!important;
/*   background-color: lightblue;
 */}

.theme--light .select-screen-image-bloc{
  width:100px!important;
  height:100px!important;
  border-radius:50em;
  margin-bottom:16px;
  background-color:var(--v-primary-base);
}

.theme--dark .select-screen-image-bloc{
  width:100px!important;
  height:100px!important;
  border-radius:50em;
  margin-bottom:16px;
  background-color: rgb(37, 39, 53);
}

.select-screen-image{
  overflow:visible;
  cursor:pointer;
  height:100%;
  width:100%;
}

.select-screen-button{
  height:30px;
  width:30px;
  position:absolute;
  z-index:1;
  bottom:0;
  right:0;
/*   cursor: initial;
 */}
</style>
